export default __webpack_public_path__ + "static/media/Settings.c8aa5d72.svg";